import React from 'react';
import superHeroIcon from '../../assets/super-power.png';
import * as S from './HeroPlus.styles';

const HeroPlus = ({data}) => {
  const {heading, subHeading, listData = []} = data || {};
  const renderList = listData => {
    return (
      <ul>
        {listData?.length
          ? listData.map(({order, boldText, normalText, highlight}, index) => {
              return order?.length ? (
                <li className={highlight ? 'highlightText inline-text' : 'inline-text'} key={index}>
                  <span className="sprite ic_tick" />
                  <p>
                    {order.map((item, key) => {
                      switch (item) {
                        case 'normalText':
                          return <span key={key}>{normalText} </span>; // Wrap normal text in span
                        case 'boldText':
                          return <strong key={key}>{boldText} </strong>; // Wrap bold text in strong
                        default:
                          return null;
                      }
                    })}
                  </p>
                </li>
              ) : null;
            })
          : null}
      </ul>
    );
  };
  if (typeof window === 'undefined') {
    return null;
  }
  return (
    <S.HeroPlusCont>
      <S.HeroPlusContLft>
        <h3>
          <span>{heading}</span>
        </h3>
        <p>{subHeading}</p>
        {/*<h5>Now get benifits <span>Every Month!</span></h5>*/}
        {renderList(listData)}
      </S.HeroPlusContLft>
      <S.HeroPlusContRht>
        <h3>
          Introducing <span>Unlimited Cashback</span>
        </h3>
        <img src={'https://assets-gos3.goibibo.com/myp_heroSS_dashboard-1680087647.svg'} alt="" />
        {/* {<h4>HERO+</h4>
        <p>
          Now make every transaction on <br />
          <span>myPartner rewarding</span>
        </p>} */}
      </S.HeroPlusContRht>
    </S.HeroPlusCont>
  );
};

export default HeroPlus;
